<template>
    <div>
    <!--Content Wrap Start-->
    <!--Content Wrap Start-->

    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>KEGIATAN</h4>
				<div class="kode_bread_crumb">
                	<ul>
                		<li><a href="/">Home</a></li>
                    	<li><router-link to="/kegiatan">KEGIATAN</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
    <!--Bread Crumb Wrap Start-->    
    <div class="kode_content" style="padding-top:5%">
    	
        <!--News List Wrap Start-->
        <section >
        	<div class="container">
            	<div class="row">
                	<div class="col-md-8 kode_news_colmn_list">
                        <!-- list berita -->
                        <div class="kode_news_list" v-for="data in list_data" :key="data.id">
                            <figure>
                                <img :src="file_path+data.foto"  alt="News List Image" >
                            </figure>
                            <div class="kode_news_list_des">
                                <span>Kegiatan</span>
                                <h6> <a href="javascript:void(0);" @click="push_kegiatan(data.id)" > {{data.nama}} </a> </h6>
                                <div class="kode_author">by <a href="#">{{data.createBy}} </a><i class="fa fa-calendar"></i> {{convert_tgl(data.tgl)}}</div>
									<!-- <ul>
										<li> <a href="#"> <i class="fa fa-heart-o"></i>144 </a> </li>
										<li> <a href="#"> <i class="fa fa-comment-o"></i>49 </a> </li>
										<li> <a href="#"> <i class="fa fa-eye"></i>12,899 </a> </li>
									</ul> -->
									<br>
                                <p v-html="limit_desk_foto(data.deskripsi)+'...'" ></p>
                            </div>
                        </div>
                        
                        <!-- list berita -->
                        
 
						<div class="clearfix clear"></div>
						<!--Pagination Wrap Start-->
						<div class="kode_pagination">
								<div class="text-center">
										<button @click="btn_prev" type="button" class="btn " id="pref">
											<span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span>
										</button>
										&nbsp;
										<span style="font-size: 85%; color: #a5a5a5">
											<b>{{page_first}} - {{page_last}}</b>
										</span>
										&nbsp;
										<button @click="btn_next" type="button" class="btn" id="next">
											<span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span>
										</button>
									</div>
						</div>
						<!--Pagination Wrap End-->
                    </div>
                    
                    <div class="col-md-4">
                    	<div class="kode_aside_search">
                        	<form>
                            	<input id="search" type="text" placeholder="Search ..." @keyup="cari_data" v-model="cari_value">
                                <button><i class="fa fa-search"></i></button>
                            </form>
                        </div>
                        
 
                        
						<!--Aside Event Wrap Start-->
                        <div class="kode_aside_event kode_aside">
                        	<h5>Kegiatan</h5>
                            <ul>
                            	<li v-for="data in kegiatan" :key="data.id">
                                	<figure>
                                    	<img :src="file_path+data.foto" alt="Image Here">
                                        <figcaption>
                                         
                                            <a href="javascript:void(0);" @click="push_kegiatan(data.id)"><i class="fa fa-link"></i></a>
                                        </figcaption>
                                    </figure>
                                    <div class="kode_aside_event_des" style="text-align:justify">
                                    	<p v-html="limit_desk_kegiatan(data.deskripsi)+' ...'"> </p>
                                    	<span><b>{{convert_tgl(data.createAt)}}</b></span>
                                    </div>
                                </li>
                                
 
                            </ul>
                        </div>
                        <!--Aside Event Wrap End-->
						
 
                        
 
                        
						<!--Aside Flicker Wrap Start-->
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
						<!--Aside Flicker Wrap End-->
                        
                    </div>
                    
                    
                </div> 
            </div>
        </section>
        <!--News List Wrap End-->
        
    </div>
    <!--Content Wrap End-->
    <!--Content Wrap End-->
    </div>
</template>



<script>




const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";


const FILE_LOAD = URL_APP+'uploads/';

export default {
  name: "web_pengumuman",
  data() {
    return {
		// active_car : '',

		id: "",
		nama: "",
		tgl: "",
		file: "",
		file_old: "",
		deskripsi: "",
		file_path: FILE_LOAD,
    
    kegiatan:[],
    kegiatan6:[],

		list_data: [],
		page_first: 1,
		page_last: 0,
		cari_value: ""
    };
  },

  // =============================================================== METHODS =========================================================================
  methods: {

	getView: function() {
      fetch(KEGIATAN_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
            console.log(res_data);
        });
    },
        getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

        getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan6 = res_data;
                //   console.log(res_data);
            });
    },     

    limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
    }, 

	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
    },    

	


	limit_desk_foto : function(text){
		return text.substring(0, 150)
	},
	// 	push_kegiatan : function(id){
	// 	this.$router.push('/isi_kegiatan/'+id);
	// },



    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev: function() {
        if (this.page_first > 1) {
            this.page_first--;
        } else {
            this.page_first = 1;
        }
        this.getView();
        },

        btn_next: function() {
        if (this.page_first >= this.page_last) {
            this.page_first == this.page_last;
        } else {
            this.page_first++;
        }
        this.getView();
        },

        cari_data: function() {
          this.getView();
        },
        onFileSelected : function(event){
            this.foto = event.target.files[0];
            console.log(this.foto);
        },
        convert_tgl : function(dateString){
			var date = new Date(dateString);
			var bulan = "";

			if (date.getMonth() == 0) {bulan = 'januari';} 
			else if (date.getMonth() == 1) {bulan = 'Februari';}
			else if (date.getMonth() == 2) {bulan = 'Maret';}
			else if (date.getMonth() == 3) {bulan = 'April';}
			else if (date.getMonth() == 4) {bulan = 'Mei';}
			else if (date.getMonth() == 5) {bulan = 'Juni';}
			else if (date.getMonth() == 6) {bulan = 'Juli';}
			else if (date.getMonth() == 7) {bulan = 'Agustus';}
			else if (date.getMonth() == 8) {bulan = 'September';}
			else if (date.getMonth() == 9) {bulan = 'Oktober';}
			else if (date.getMonth() == 10) {bulan = 'November';}
			else if (date.getMonth() == 11) {bulan = 'Desember';}
			else{bulan = ''}

          return date.getDate()+" "+bulan+" "+date.getFullYear();
        },
    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
	this.getView();
    this.getKegiatan();
	this.getKegiatan6();
  },

};





$("#slider > .sl-slide:gt(0)").hide();

setInterval(function() {
  $('#slider > .sl-slide:first')
    .fadeOut(1000)
    .next()
    .fadeIn(1000)
    .end()
    .appendTo('#slider');
}, 3000);


function myMap() {
var mapProp= {
  center:new google.maps.LatLng(-4.836928, 122.715091),
  zoom:5,
};
var map = new google.maps.Map(document.getElementById("map-canvas"),mapProp);
}



</script>


 